import { ReactNode } from "react"
import { client } from "src/graphql"
import { GET_ROOM } from "src/pages/home/graphql/queries/rooms.query"
import { useVentaEnLineaAcciones } from "src/pages/home/room-detail/drawer/venta-en-linea/hooks/useVentaEnLineaAcciones"
import { useProfile } from "src/shared/hooks/useProfile"
import useSnackbar from "src/shared/hooks/useSnackbar"
import useIsColaboradorActive from "src/shared/hooks/useIsColaboradorActive"

// Slider de las cards de venta en línea: a tiempo va directo a la venta de habitación y en no show pide autorización
// para liberarla, sin abrir el detalle de la habitación
export const useVentaEnLineaFooter = ({ room, isNoShow }: { room: any; isNoShow: boolean }) => {
    const { usuario_id, hotel_id } = useProfile()
    const { showSnackbar } = useSnackbar()
    const { InactiveModal, validateIsColabActive } = useIsColaboradorActive()
    const { canOperate, checkIn, solicitarLiberar, LiberarModal } = useVentaEnLineaAcciones()

    // La lista de habitaciones no trae la renta completa (tarifa, pagos, reserva) que necesita la venta
    const onCheckIn = async () => {
        try {
            const { data } = await client.query({
                query: GET_ROOM,
                variables: { habitacion_id: room?.habitacion_id, usuario_id, hotel_id },
                fetchPolicy: "no-cache",
            })
            checkIn(data.habitacion)
        } catch {
            showSnackbar({
                title: "Error al cargar la habitación",
                status: "error",
                text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente",
            })
        }
    }

    const onSliderTriggered = canOperate
        ? validateIsColabActive(() => (isNoShow ? solicitarLiberar(room) : onCheckIn()))
        : undefined

    // Los clics del slider y de los modales no deben llegar a la card, que abre el detalle
    const withoutCardClick = (children: ReactNode) => (
        <div style={{ display: "contents" }} onClick={(e) => e.stopPropagation()}>
            {children}
            {LiberarModal}
            {InactiveModal}
        </div>
    )

    return {
        text: isNoShow ? "Liberar habitación" : "Check in",
        onSliderTriggered,
        withoutCardClick,
    }
}
